<template>
    <div class="page bg-fff text-center">
        <backTitleBar :isBackClose="true" :isLogOut="true"></backTitleBar>
        <img :src="mainImg" alt="" class="main-img">
        <div class="fs-36 color-333 mt-25 font-bold">审核中</div>
        <div class="fs-28 color-999 mt-20">请等待1-3个工作日，通过后客服会与您联系</div>
        <div class="btn click" @click="back">
            完成
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "checking",
        components:{backTitleBar},
        data(){
            return{
                mainImg: require("../../../assets/images/shopRegister/checking.png")
            }
        },
        methods:{
            back(){
                try{
                    window.native.getApp();
                    this.$dialog.alert({
                        title: "提示",
                        message: "将退出登录，是否确定",
                        showCancelButton: true
                    })
                        .then(() => {     //点击确认按钮后的调用
                            window.native.toLogin();
                        })
                        .catch(() => { //点击取消按钮后的调用
                            console.log("cancel")
                        })
                }catch (e) {
                    this.$router.go(-1)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-img{
        width: 1.28rem;
        height: 1.28rem;
        margin-top: 1.4rem;
    }
    .btn{
        width: 2.8rem;
        height: .88rem;
        line-height: .88rem;
        text-align: center;
        background: #F4F4F4;
        border-radius: .12rem;
        color: $main-color;
        font-size: .34rem;
        margin: 5rem auto 0;
    }
</style>



// WEBPACK FOOTER //
// checking.vue?321222f3